export const REQUEST_COLORS = ['#F9B64F', '#F49EB9', '#6EBFB5', '#AECDE1', '#808080', '#E57373', '#BA68C8', '#4FC3F7', '#AED581', '#FFD54F', '#FF8A65', '#90A4AE'];

export const DEPARTMENT_COLORS = ['#FDDCC8', '#FDC8D8', '#C8FDFA', '#C8E6FD', '#E0E0E0', '#FDC8C8', '#F0C8FD', '#C8F1FD', '#D8FDC8', '#FDEFC8', '#FDD8C8', '#D8E0E6'];
